import { useEffect } from 'react';
import { useEditorStore } from '../store/editorStore';
import { usePlaybackStore } from '../store/playbackStore';

function isEditing(target: EventTarget | null) {
  return target instanceof HTMLElement && (target.matches('input, textarea, select, [contenteditable="true"]') || Boolean(target.closest('[role="dialog"]')));
}

export function useKeyboardShortcuts() {
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      const editor = useEditorStore.getState();
      const project = editor.project;
      const composition = project.compositions[project.activeCompositionId];
      const command = event.metaKey || event.ctrlKey;
      if (command && event.key.toLowerCase() === 'k') { event.preventDefault(); editor.setModal('command'); return; }
      if (command && event.key.toLowerCase() === 's') { event.preventDefault(); editor.showToast('Autosave is up to date', 'success'); return; }
      if (command && event.key.toLowerCase() === 'e') { event.preventDefault(); editor.setModal('export'); return; }
      if (command && event.key.toLowerCase() === 'i') { event.preventDefault(); editor.setLeftPanel('media'); return; }
      if (command && event.key.toLowerCase() === 'd') { event.preventDefault(); editor.duplicateSelection(); return; }
      if (command && event.key.toLowerCase() === 'z') { event.preventDefault(); event.shiftKey ? editor.redo() : editor.undo(); return; }
      if (isEditing(event.target)) return;
      const playback = usePlaybackStore.getState();
      switch (event.key.toLowerCase()) {
        case ' ': event.preventDefault(); playback.toggle(); break;
        case 'j': playback.setRate(Math.max(-4, playback.rate > 0 ? -1 : playback.rate * 2)); playback.setPlaying(true); break;
        case 'k': playback.setPlaying(false); break;
        case 'l': playback.setRate(Math.min(4, playback.rate < 0 ? 1 : playback.rate * 2)); playback.setPlaying(true); break;
        case 'arrowleft': event.preventDefault(); playback.step(event.shiftKey ? -10 : -1, composition.fps); break;
        case 'arrowright': event.preventDefault(); playback.step(event.shiftKey ? 10 : 1, composition.fps); break;
        case 's': editor.splitSelection(); break;
        case 'm': editor.addMarker(); break;
        case 'n': editor.toggleSnapping(); break;
        case 't': editor.addLayer('text'); break;
        case 'delete': case 'backspace': event.preventDefault(); editor.removeSelection(event.shiftKey); break;
        case 'escape': editor.setModal(null); editor.selectLayer(null); break;
        case 'f11': event.preventDefault(); void document.querySelector('.preview-panel')?.requestFullscreen(); break;
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);
}
